// src/api/boardApi.js
import axios from "axios";
import { attachAuthInterceptors } from "./attachInterceptors";
import { createApi } from './createApi';
export const initBoardApi = (logout) => createApi(process.env.REACT_APP_API_BOARD, logout);

const boardApi = axios.create({
  baseURL: process.env.REACT_APP_API_BOARD, // ex) http://localhost:8801/api
  headers: {
    "Content-Type": "application/json",
  },
});

// ✅ JWT 토큰 자동 포함
attachAuthInterceptors(boardApi);

//
// ✅ 게시판 관련
//

// 게시판 목록 조회
export const fetchBoards = () => boardApi.get("/api/boards/");

//
// ✅ 게시글 관련 (게시판 내 nested 구조)
//

// 특정 게시판의 게시글 목록 조회
export const fetchPosts = (boardSlug, params = {}) =>
  boardApi.get(`/api/boards/${boardSlug}/posts/`, { params });

export const fetchPostDetail = (boardSlug, postId) =>
  boardApi.get(`/api/boards/${boardSlug}/posts/${postId}/`);

// 게시글 생성
export const createPost = (boardSlug, data) =>
  boardApi.post(`/api/boards/${boardSlug}/posts/`, data);

// 게시글 수정
export const updatePost = (boardSlug, postId, data) =>
  boardApi.put(`/api/boards/${boardSlug}/posts/${postId}/`, data);

// 게시글 삭제
export const deletePost = (boardSlug, postId) =>
  boardApi.delete(`/api/boards/${boardSlug}/posts/${postId}/`);

//
// ✅ 게시글 단일 조회 (boardSlug 없이 ID만으로 조회)
//

// 단일 게시글 상세 조회 (id 기반)
export const getPost = (postId) => boardApi.get(`/api/posts/${postId}/`);

export default boardApi;
